import { paginationField } from './consts';

export default function(editor, opts = {}) {
  const bm = editor.BlockManager;
  const pfx = opts.pfx;

  const style = opts.defaultStyle
    ? `<style>
    .${pfx}-cont,
    .block {
      display: inline-block;
    }
  </style>`
    : '';

  if (opts.blocks.indexOf(paginationField) >= 0) {
    bm.add(paginationField, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="32" height="50"><!-- Font Awesome Free 5.15.3 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"/></svg>
      <div class="gjs-block-label">${opts.label}</div>`,
      category: opts.category,
      content: `
        <div class="${pfx}" data-gjs-type="pagination"  data-gjs="pagination">
          <button type="button"  class="btn btn-sm btn-outline-primary first">First</button>
          <button type="button"  class="btn btn-sm btn-outline-primary previous">Previous</button>
          <button type="button" class="btn btn-sm btn-outline-primary next">Next</button>
          <button type="button" class="btn btn-sm btn-outline-primary last">Last</button>
        </div> 
        ${style}
      `,
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="#" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        opts.label
      }?"></i>
        </a>
      </span>
    `,
    });
  }
}
